import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './UserAvatar.css';

/**
 * UserAvatar Component
 * Displays user profile picture or initials in a round avatar
 * @param {Object} user - User object with name and photo
 * @param {number} size - Size of the avatar in pixels
 * @param {function} onClick - Click handler
 */
const UserAvatar = ({user, size = 40, onClick}) => {
  const [imageError, setImageError] = useState(false);

  const getInitial = () => {
    if (!user) return 'U';
    if (user.name) {
      return user.name.charAt(0).toUpperCase();
    }
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const showImage = user?.photo && !imageError;

  return (
    <button
      className="user-avatar"
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size * 0.4}px`
      }}
      title={user?.name || user?.email || 'User Profile'}
      type="button"
    >
      {showImage ? (
        <img 
          alt={user.name || 'User'} 
          className="user-avatar-image" 
          onError={handleImageError}
          src={user.photo}
        />
      ) : (
        <span className="user-avatar-initial">{getInitial()}</span>
      )}
    </button>
  );
};

UserAvatar.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    photo: PropTypes.string,
  }),
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default UserAvatar;
